import cookie from "js-cookie";

const COOKIE = "custom_tags";

export function parseCustomTags(raw) {
  const list = Array.isArray(raw) ? raw : [raw];
  const tags = list
    .flatMap((item) => String(item ?? "").split(","))
    .map((tag) => tag.trim())
    .filter(Boolean);
  return [...new Set(tags)];
}

export function setCustomTags(tags) {
  if (tags.length) cookie.set(COOKIE, JSON.stringify(tags));
  else cookie.remove(COOKIE);
}

export function getCustomTags() {
  try {
    return parseCustomTags(JSON.parse(cookie.get(COOKIE) || "[]"));
  } catch {
    return [];
  }
}
